import { Injectable } from '@angular/core';
import { assign } from 'lodash';

// Services
import { ApiService } from 'src/app/services/api.service';

// App State
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState, UPDATE_ACTIVE_SUBMISSION, QUEUE_REMOVE } from '../app-reducer';

@Injectable({
    providedIn: 'root'
})

export class QueuesService {
    appState$: Observable<any>;

    constructor(
        private store: Store<AppState>,
        private apiService: ApiService
    ) {
        this.appState$ = store.select('sections');
    }

    start() {
        this.appState$.subscribe((state: any) => {
            // check if payload submission is necessary
            if (state.appAuthId && state.appId && !state.activeSubmission && state.payloadQueue.length > 0) {
                const payload = assign(state.payloadQueue[0], { AppAuthId: state.appAuthId, AppId: state.appId})
                this.submitPayload(payload);
            }
        });
    }

    // utility: submit payload
    submitPayload(payload: any) {
        console.log('submit payload',(new Date()));
        // update payload queue
        this.store.dispatch({
            type: UPDATE_ACTIVE_SUBMISSION,
            payload: true
        });

        // payload for submission
        this.apiService.submitPayload(payload)
        .subscribe((response: any) => {
            // remove submitted section
            this.store.dispatch({
                type: QUEUE_REMOVE
            });

            // update active state
            window['setTimeout'](() => {
                this.store.dispatch({
                type: UPDATE_ACTIVE_SUBMISSION,
                payload: false
                });
            }, 150);
        }, (errorResponse: any) => {
            // update payload queue
            this.store.dispatch({
                type: UPDATE_ACTIVE_SUBMISSION,
                payload: false
            });
        });
    }
}
